import React from 'react';
import DatePicker from 'react-datepicker';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

import Card from '@/components/common/Card';
import GrayButton from '@/components/common/elements/GrayButton';
import detailsImage from '@/components/common/icons/client-details.svg';
import fileExport from '@/components/common/icons/file-export.svg';
// import classes from '@/components/InspectorsPage/InspectorReport/style.module.scss';

const InspectorReportComponent = ({
  id,
  status,
  isBusy,
  onClick,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  intl,
}) => (
  <div className="flex flex-col items-center justify-center py-[1.5em] px-[1em] space-y-1">
    <Card className="fade-in">
      <h2 className="flex items-center mb-[1.4em] pb-[1.4em] border-b border-[#eee] !text-[1.25em] !font-bold leading-[1.3] text-[#393939] relative">
        <div className="mr-2 w-6 h-6 relative top-[2px] flex items-center justify-center">
          <Link to={`/inspectors/${status}/${id}`}>
            <div className="w-[14px] h-[14px] border-l-2 border-b-2 border-[#393939] rotate-45 relative left-1" />
          </Link>
        </div>
        <div className="mr-2 w-[26px] h-auto flex items-center justify-center">
          <img src={detailsImage} alt={intl.formatMessage({ id: 'DETAILS' })} />
        </div>
        {intl.formatMessage({ id: 'REPORT_EXPORT' })}
      </h2>
      <p className="max-w-[400px] mx-auto mb-8 text-center text-[#919191] font-semibold text-[0.93875em]">
        {intl.formatMessage({ id: 'INSPECTOR_INDIVIDUAL_SPREADSHEET_GENERATE_MESSAGE' })}
      </p>
      <form className="flex flex-col items-center">
        <div className="flex justify-center mb-4">
          <div className="flex flex-col justify-center items-start mr-3">
            <label className="mb-1 text-[0.75em] font-semibold uppercase text-[#3c3c3c]" htmlFor="startDate">
              {intl.formatMessage({ id: 'FROM_DAY' })}
            </label>
            <DatePicker
              id="startDate"
              name="startDate"
              placeholderText={intl.formatMessage({ id: 'INITIAL_DATE' })}
              className="h-10 px-[10px] py-1.5 border border-[#e3e3e3] rounded-[3px] bg-white font-semibold text-[#919191] focus:outline-none focus:border-[#4d8fca] transition-colors"
              autoComplete="off"
              locale="pt-BR"
              dateFormat="dd 'de' MMMM 'de' yyy"
              onChange={onStartDateChange}
              selectsStart
              startDate={startDate}
              maxDate={new Date()}
              endDate={endDate}
              selected={startDate}
              popperPlacement="top-end"
            />
          </div>
          <div className="flex flex-col justify-center items-start">
            <label className="mb-1 text-[0.75em] font-semibold uppercase text-[#3c3c3c]" htmlFor="endDate">
              {intl.formatMessage({ id: 'TO_DAY' })}
            </label>
            <DatePicker
              id="endDate"
              name="endDate"
              placeholderText={intl.formatMessage({ id: 'FINAL_DATE' })}
              className="h-10 px-[10px] py-1.5 border border-[#e3e3e3] rounded-[3px] bg-white font-semibold text-[#919191] focus:outline-none focus:border-[#4d8fca] transition-colors"
              autoComplete="off"
              locale="pt-BR"
              dateFormat="dd 'de' MMMM 'de' yyy"
              onChange={onEndDateChange}
              selectsEnd
              endDate={endDate}
              maxDate={new Date()}
              minDate={startDate}
              selected={endDate}
              popperPlacement="top-end"
            />
          </div>
        </div>
        <GrayButton onClick={onClick} isBusy={isBusy}>
          <img src={fileExport} alt={intl.formatMessage({ id: 'METRICS' })} className="!w-5 mr-2" />
          {intl.formatMessage({ id: 'REPORT_EXPORT' })}
        </GrayButton>
      </form>
    </Card>
  </div>
);

InspectorReportComponent.propTypes = {
  id: PropTypes.string,
  status: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isBusy: PropTypes.bool.isRequired,
  startDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]),
  endDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]),
  onStartDateChange: PropTypes.func.isRequired,
  onEndDateChange: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

InspectorReportComponent.defaultProps = {
  id: null,
  startDate: null,
  endDate: null,
};

export default InspectorReportComponent;
